import { Aula, AulaId, AulaInstructor, AulaDay, AulaUrl, AulaInstagram } from '../../domain/entities/Aula';
import { AulaRepository } from '../../domain/repositories/AulaRepository';
import { GoogleSheetsService, SpreadsheetData } from '../services/GoogleSheetsService';
import { GOOGLE_SHEETS_CONFIG } from '../../shared/constants/GoogleSheetsConfig';

export class GoogleSheetsAulaRepositoryImpl implements AulaRepository {
  private sheetsService: GoogleSheetsService;

  constructor() {
    // Usar gid=1842076185 para a aba "Aulas"
    console.log('GoogleSheetsAulaRepositoryImpl: Usando gid=1842076185 para aba Aulas');
    this.sheetsService = new GoogleSheetsService(GOOGLE_SHEETS_CONFIG.SPREADSHEET_ID, '1842076185');
  }

  async findAll(): Promise<Aula[]> {
    try {
      const spreadsheetData = await this.sheetsService.loadSpreadsheet();
      
      if (!spreadsheetData) {
        console.warn('Não foi possível carregar dados das aulas da planilha');
        return [];
      }

      const aulas = this.parseSpreadsheetData(spreadsheetData);
      console.log(`Aulas carregadas da planilha: ${aulas.length}`);
      return aulas;
    } catch (error) {
      console.error('Erro ao carregar aulas da planilha:', error);
      return [];
    }
  }

  async findById(id: string): Promise<Aula | null> {
    const allAulas = await this.findAll();
    return allAulas.find(aula => aula.id.value === id) || null;
  }

  private parseSpreadsheetData(data: SpreadsheetData): Aula[] {
    const aulas: Aula[] = [];
    
    if (!data.table || !data.table.rows) {
      console.warn('Estrutura de dados inválida para aulas');
      return aulas;
    }

    console.log('Total de linhas na planilha de aulas:', data.table.rows.length);
    console.log('Estrutura das colunas de aulas:', data.table.cols);

    // Processar todas as linhas, mas pular cabeçalhos se necessário
    for (let i = 0; i < data.table.rows.length; i++) {
      const row = data.table.rows[i];
      
      console.log(`Processando linha de aula ${i}:`, row);
      
      if (!row.c || row.c.length < 2) {
        console.warn(`Linha ${i} tem dados insuficientes para aula:`, row.c);
        continue;
      }

      // Verificar se é cabeçalho (primeira linha com títulos das colunas)
      const firstCell = row.c[0]?.v?.toString() || '';
      if (i === 0 && (firstCell.toLowerCase() === 'instrutor' || firstCell.toLowerCase() === 'instructor')) {
        console.log(`Pulando cabeçalho na linha ${i}`);
        continue;
      }

      try {
        const aula = this.parseRowToAula(row, i);
        if (aula) {
          aulas.push(aula);
          console.log('Aula criada com sucesso:', aula.instructor.value);
        } else {
          console.warn(`Linha ${i} não gerou aula válida`);
        }
      } catch (error) {
        console.error(`Erro ao processar linha de aula ${i}:`, error);
      }
    }

    console.log('Total de aulas processadas:', aulas.length);
    return aulas;
  }

  private parseRowToAula(row: { c: Array<{ v: string | number | null; f?: string }> }, rowNumber: number): Aula | null {
    const cells = row.c;
    
    console.log(`Parseando linha de aula ${rowNumber} - células:`, cells);
    
    // Mapear os campos da aba Aulas: [Instrutor, Dia, URL, Instagram]
    const instructor = cells[0]?.v?.toString() || '';
    const day = cells[1]?.v?.toString() || '';
    const url = cells[2]?.v?.toString() || '';
    const instagram = cells[3]?.v?.toString() || '';

    console.log(`Campos extraídos - Instrutor: "${instructor}", Dia: "${day}", URL: "${url}"`);

    if (!instructor || !day) {
      console.warn(`Linha ${rowNumber} tem dados obrigatórios ausentes - instrutor: "${instructor}", dia: "${day}"`);
      return null;
    }

    const aula = new Aula(
      { value: `aula-${rowNumber}` } as AulaId,
      { value: instructor.trim() } as AulaInstructor,
      { value: day.trim() } as AulaDay,
      { value: url.trim() } as AulaUrl,
      { value: instagram.trim() } as AulaInstagram
    );

    console.log(`Aula criada:`, aula);
    return aula;
  }


} 